import { Modal } from "@visiblethread/react-components";
import { DOC_SOURCE } from "constants/documents";
import { useContext, useMemo, useState } from "react";

import DocumentDetachOptions, {
  areDetachParamsValid,
  getInitialDetachParams,
} from "../../../DocumentDetachOptions";
import StartWritingProposalOutlineContext from "../context";
import common from "./common.module.scss";
import { GENERATE_BTN } from "./constants";
import ModalFooter from "./ModalFooter";
import WizardProgressBar from "./WizardProgressBar";

const ResolveOutlineConflicts = () => {
  const { childSections, onResolveConflicts, source, templateId } = useContext(
    StartWritingProposalOutlineContext
  );
  const isAddInDocument = source === DOC_SOURCE.ADDIN;

  const [deleteDocument, setDeleteDocument] = useState();
  const [detachParams, setDetachParams] = useState(
    getInitialDetachParams(childSections)
  );

  const onClickNext = () => {
    onResolveConflicts({
      deleteDocument,
      detachParams,
      source,
      templateId,
    });
  };

  const isNextDisabled = useMemo(() => {
    switch (true) {
      case deleteDocument === true:
      case deleteDocument === false && areDetachParamsValid(detachParams):
        return false;
      default:
        return true;
    }
  }, [deleteDocument, detachParams]);

  return (
    <>
      <Modal.Body className={common.body}>
        <p>
          This section contains child sections with link(s) to doc(s). We can
          create a doc with all the sub-section(s) and remove old link(s).
        </p>

        <WizardProgressBar value={66} />

        <p>Choose how you want to proceed:</p>

        <DocumentDetachOptions
          deleteDocument={deleteDocument}
          detachParams={detachParams}
          onChangeDelete={setDeleteDocument}
          onUpdateFileNames={setDetachParams}
        />
      </Modal.Body>

      <ModalFooter
        isNextDisabled={isNextDisabled}
        nextButtonText={GENERATE_BTN}
        onClickNext={onClickNext}
        stepNumber={isAddInDocument ? 3 : 2}
      />
    </>
  );
};

export default ResolveOutlineConflicts;
